<template>
  <div v-if="comp_load">
    <v-btn
      color="primary darken-1"
      @click="$router.go(-1)"
      class="d-print-none"
    >
      <v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>
      Back
    </v-btn>
    <v-card outlined elevation="1" id="print">
      <!-- /print card ------------->
      <v-card class="d-flex justify-center mt-4" flat tile>
        <v-card-title class="subtitle-2 font-weight-bold"
          >Receipt No: {{ receipt_data.receipt_no }}
        </v-card-title>
      </v-card>

      <!-- /1 row ------------->

      <v-card
        class="d-flex justify-space-between mx-10 mt-n5 d-print-flex"
        flat
        tile
      >
        <v-card flat tile>
          <v-card-title class="subtitle-2 font-weight-bold"
            >GR.No: {{ receipt_data.stud_reg_no }}
          </v-card-title>
        </v-card>
        <v-card flat tile>
          <v-card-title class="subtitle-2 font-weight-bold"
            >Receipt Date: {{receipt_data.receipt_date}}
          </v-card-title>
        </v-card>
      </v-card>
      <!-- /2 row ------------->
      <v-card class="d-flex justify-center mt-n5" flat tile>
        <v-card-title class="body-2 font-weight-normal"
          >Recieved with thanks application admission fees for the admission
          year {{receipt_data.ay}} form</v-card-title
        >
      </v-card>
      <!-- /3 row ------------->

      <v-card class="d-flex justify-center mt-n4" flat tile>
        <v-card-title class="subtitle-2 font-weight-bold text-uppercase"
          >{{ receipt_data.stud_name }}
        </v-card-title>
      </v-card>
      <!-- /4 row ------------->
      
      <template>
        <v-simple-table dense class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"><b>Sr.No</b></th>
                <th class="text-left"><b>Component</b></th>
                <th class="text-left"><b>Amount</b></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in comp_list" :key="item.name">
                <td>{{ index+1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr><td> </td> <th><b>Total</b> </th><th> <b>{{receipt_data.receipt_amount}} </b></th></tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
          <br>
        <template>
        <v-simple-table dense class="table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"><b>Payment Mode</b></th>
                <th class="text-left"><b>DD No./Cheque No./Transaction No.</b></th>
                <th class="text-left"><b>Date</b></th>
                <th class="text-left"><b>Amount(Rs.)</b></th>
                <th class="text-left"><b>Drawn On</b></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in trans_list" :key="item.name">
                <td>{{ item.mode}}</td>
                <td>
                  <span v-if="item.transid"> {{ item.transid }}</span> 
                  <span v-if="!item.transid">--</span>
                </td>
                <td>{{ item.date }}</td>
                <td>{{ item.amount }}</td>
                <td>
                   <span v-if="item.bank"> {{ item.bank }}</span>
                   <span v-if="!item.bank"> --</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>

      <v-card class="d-flex justify-end mr-10 mb-4 mt-4" flat tile>
        <v-btn
          class="ma-2 d-print-none"
          tile
          outlined
          color="warning"
          @click="print()"
        >
          <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
        </v-btn>
      </v-card>
    </v-card>
    <!-- /end of print ------------->
    
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    receipt_data: {
      receipt_id: null,
      stud_reg_no: null,
      receipt_no: null,
      receipt_amount: null,
      stud_name: null
    },
    comp_list: null,
    trans_list: null,
    comp_load: false,
  }),
  mounted() {
    this.receipt_data.receipt_id = this.$store.getters.receipt_id;
    axios
      .post("/feesPayment/admissionFeesReceipt", this.receipt_data)
      .then(res => {
        if (res.data.msg == "200") {
          if (res.data.status == "SUCCESS") {
            this.receipt_data = res.data.receipt_data;
            this.comp_list = res.data.comp_list;
            this.trans_list = res.data.trans_list;
          } else {
            alert(res.data.status_reason);
          }
        } else {
          //error
        }
      })
      .catch(error => {
        window.console.log(error);
      })
      .finally(() => {
        //close loader
        this.comp_load = true;
      });
  },
  methods: {
   
    print() {
      this.$store.state.drawer = false;
      let that = this;
      /*window.onbeforeprint = function() {
        that.$store.state.drawer = false;
      };*/
      window.onafterprint = function() {
        that.$store.state.drawer = true;
      };
      setTimeout(function(){ window.print(); }, 100);
    },
  },
  
};
</script>
<style scoped>
 .table{
width: 70%; margin: 0 auto; border: 1px solid #ededed
 }
@media print {
  @page { size: landscape; }
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  .d-flex {
    margin: 1% !important;
  }
}
</style>
